<div class="bdo-table bdo-mb-45">

  <div class="bdo-tile">
    <h5 class="bold re-mb-10">{{ 'consumptionHistory.table.title' | translate }}</h5>
    @for (zaehler of historie; track zaehler) {
      <div>
        {{ 'meterreadings.input.meterId'  | translate }}
        <span class="bold">{{zaehler?.meterNumber}}</span>
        @if (zaehler?.ablesungen && zaehler?.sparte === sparteEnum.Strom) {
          <span>
            -
            @if (zaehler?.imsys) {
              {{ 'meterreadings.meterTypes.ims' | translate }}
            } @else {
              {{ ((zaehler?.ablesungen[0]?.staende.length > 1) ?
              'meterreadings.meterTypes.htNtMeter' : 'meterreadings.meterTypes.oneTariffMeter') | translate }}
            }
          </span>
        }
        @if (zaehler?.inaktivSeit) {
          <span> (inaktiv seit {{zaehler?.inaktivSeit | date}})</span>
        }
      </div>
    }

    <!-- chart/table-toggle -->
    @if (imsysContracts?.includes(vertragNummer) && state === LoadingState.IDLE) {
      <bdo-toggle-button
      [description]="(showTable ?
                      'consumptionHistory.table.showGraphic' :
                       'consumptionHistory.table.showTable') | translate"
        [enabled]="showTable"
        [labelLeft]="'consumptionHistory.table.switchGraphic' | translate"
        [labelRight]="'consumptionHistory.table.switchTable' | translate"
        [mode]="'switch'"
        (toggle)="toggleView()"
      ></bdo-toggle-button>
    }
  </div>

  <div class="re-relative">
    @if (state === LoadingState.LOADING) {
      <bdo-loading></bdo-loading>
    }

    <!-- show errors on all backend errors -->
    @if (state === LoadingState.ERROR) {
      <bdo-info-box class="bdo-container--single">
        {{ 'general.error.error' | translate }}
      </bdo-info-box>
    }

    @if (showTable && state === LoadingState.IDLE && !imsysContracts?.includes(vertragNummer)) {
      <bdo-zaehlerstand-historie-tabelle
        [ablesungen]="ablesungen"
      ></bdo-zaehlerstand-historie-tabelle>
    }

    @if (state === LoadingState.IDLE && imsysContracts?.includes(vertragNummer)) {
      <bdo-diagramm
        [contractId]="vertragNummer"
        [showTable]="showTable"
      ></bdo-diagramm>
    }
  </div>
</div>
